(function (angular) {
    'use strict';

    angular.module('sms')
        /**
         *
         */
        .controller('inboundCtrl',
        ['$scope', 'dedicatedNumbers', 'keywords', 'shortcodes','$uibModalInstance',
                function ($scope, dedicatedNumbers, keywords, shortcodes,  $uibModalInstance) {

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };

                    let merged = keywords.concat(shortcodes);

                    $scope.inbound = {
                        dedicatedNumbers: dedicatedNumbers.length === 0 ? [{}] : dedicatedNumbers,
                        keywords: merged.length === 0 ? [{}] : merged,
                    };

                }]);


})(window.angular);
